
import Navbar from "./navbar";
import contactus from "./contactus.webp";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useState } from "react";


function ContactUs() {
    const [form, setForm] = useState({ name: "", email: "", phone: "", message: "" });
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const validatePhone = (phone) => {
        // Accepts formats like +91 12345 67890, 1234567890, (123) 456-7890, 123-456-7890
        const phoneRegex = /^(\+\d{1,3}[- ]?)?\d{10}$/;
        return phone.trim() === "" || phoneRegex.test(phone.replace(/[- )(]/g, ""));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validatePhone(form.phone)) {
            toast.error("Please enter a valid 10-digit phone number.");
            return;
        }
        setLoading(true);
        try {
            const res = await fetch("http://localhost:8000/api/mail/send-mail", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(form),
            });
            if (!res.ok) throw new Error("Failed to send message");
            toast.success("Message sent successfully!");
            setForm({ name: "", email: "", phone: "", message: "" });
        } catch (err) {
            toast.error("Failed to send message. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <ToastContainer />
            <div className="fixed top-0 w-full z-50">
                <Navbar />
            </div>
            <div className="relative min-h-screen bg-fixed bg-center bg-cover" style={{ backgroundImage: `url(${contactus})` }}>
                {/* Semi-transparent overlay for better text contrast */}
                <div className="absolute inset-0 bg-black/10"></div>
                {/* Main content */}
                <div className="relative pt-20 min-h-screen container mx-auto px-4 lg:px-8">
                    <div className="flex flex-col lg:flex-row items-center justify-between gap-8 h-full py-12">
                        {/* Hero Text */}
                        <div className="lg:w-1/2 space-y-4">
                            <h1 className="text-5xl md:text-7xl lg:text-8xl font-bold text-black leading-tight">
                                Start the <br className="hidden md:block" />
                                <span className="text-black">Conversation</span>
                            </h1>
                            <p className="text-xl md:text-2xl text-black max-w-2xl">
                                We're here to help. Reach out to us for any queries or assistance.
                            </p>
                        </div>
                        {/* Contact Form */}
                        <div className="lg:w-1/2 w-full max-w-lg">
                            <form className="bg-white/90 backdrop-blur-sm shadow-xl rounded-2xl p-8 space-y-6" onSubmit={handleSubmit}>
                                <div className="space-y-4">
                                    <div>
                                        <label htmlFor="name" className="block text-lg font-medium text-gray-700">
                                            Name
                                        </label>
                                        <input
                                            type="text"
                                            name="name"
                                            id="name"
                                            // placeholder="e.g., John Doe"
                                            value={form.name}
                                            onChange={handleChange}
                                            className="mt-1 w-full px-4 py-3 text-gray-900 border-b-2 border-gray-300 \
                                                     focus:border-blue-500 focus:outline-none focus:ring-0 \
                                                     transition-colors duration-200 bg-transparent"
                                            required
                                        />
                                    </div>
                                    <div>
                                        <label htmlFor="email" className="block text-lg font-medium text-gray-700">
                                            Email
                                        </label>
                                        <input
                                            type="email"
                                            name="email"
                                            id="email"
                                            // placeholder="e.g., johndoe@example.com"
                                            value={form.email}
                                            onChange={handleChange}
                                            className="mt-1 w-full px-4 py-3 text-gray-900 border-b-2 border-gray-300 \
                                                     focus:border-blue-500 focus:outline-none focus:ring-0 \
                                                     transition-colors duration-200 bg-transparent"
                                            required
                                        />
                                    </div>
                                    <div>
                                        <label htmlFor="phone" className="block text-lg font-medium text-gray-700">
                                            Phone
                                        </label>
                                        <input
                                            type="tel"
                                            name="phone"
                                            id="phone"
                                            // placeholder="e.g., +91 12345 67890"
                                            value={form.phone}
                                            onChange={handleChange}
                                            className="mt-1 w-full px-4 py-3 text-gray-900 border-b-2 border-gray-300 \
                                                     focus:border-blue-500 focus:outline-none focus:ring-0 \
                                                     transition-colors duration-200 bg-transparent"
                                        />
                                    </div>
                                    <div>
                                        <label htmlFor="message" className="block text-lg font-medium text-gray-700">
                                            Message
                                        </label>
                                        <textarea
                                            name="message"
                                            id="message"
                                            rows="4"
                                            placeholder="Enter your message"
                                            value={form.message}
                                            onChange={handleChange}
                                            className="mt-1 w-full px-4 py-3 text-gray-900 border-b-2 border-gray-300 \
                                                     focus:border-blue-500 focus:outline-none focus:ring-0 \
                                                     transition-colors duration-200 bg-transparent resize-none"
                                            required
                                        />
                                    </div>
                                </div>
                                <div className="pt-4">
                                    <button
                                        type="submit"
                                        className="w-full bg-blue-600 text-white px-6 py-3 rounded-full text-lg font-semibold\n                                                 hover:bg-blue-700 transform hover:scale-[1.02] transition-all duration-200\n                                                 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2\n                                                 shadow-lg hover:shadow-xl"
                                        disabled={loading}
                                    >
                                        {loading ? "Sending..." : "Send Message"}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                {/* Footer */}
                <div className="bg-white py-8 mt-10">
                    <div className="container mx-auto px-4">
                        <div className="text-black text-center">
                            <p className="text-lg font-serif">© 2025 HRCPRO. All rights reserved.</p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default ContactUs;